// Usage
// await delayStopper(300);

export const delayStopper = (time) =>
  new Promise((resolve) => {
    setTimeout(() => resolve(), time);
  });
